
export default {
  props: ['value', 'maxWidth'],
  data () {
    return {
      currentFilter: null
    }
  },
  methods: {
    removeFilter (i) {
      // necessary to force the slide group to show the last item event if it becomes hidden to the left
      this.currentFilter = i - 1
      this.value.splice(i, 1)
      this.$emit('input', this.value)
    },
    labels (filter) {
      let operator = '= '
      if (filter.type === 'nin' || filter.type === 'neq') operator = '&ne;'
      if (filter.type === 'starts') operator = 'commence par'
      let value = this.$root.$options.filters.cellValues(filter.values || filter.value, filter.field)
      if (filter.type === 'interval') {
        if (filter.minValue === '*' || !filter.minValue) {
          operator = '&leq;'
          value = this.$root.$options.filters.cellValues(filter.maxValue, filter.field)
        } else if (filter.maxValue === '*' || !filter.maxValue) {
          operator = '&GreaterEqual;'
          value = this.$root.$options.filters.cellValues(filter.minValue, filter.field)
        } else {
          return [
            { operator: '&GreaterEqual;', value: this.$root.$options.filters.cellValues(filter.minValue, filter.field) },
            { operator: '&leq;', value: this.$root.$options.filters.cellValues(filter.maxValue, filter.field) }
          ]
        }
      }
      if (filter.type === 'search') operator = 'contient les mots'
      if (filter.type === 'contains') operator = 'contient les caractères'
      return [{ operator, value }]
    }
  }
}
